export class Accommodation {
    name: string;
    id: number;
    code: string;
}